export default function generateComparator(rules) {
  let idx = 0
  let lines = []

  for (let [field, order] of rules) {
    lines.push(`const a${idx} = a['${field}']`)
    lines.push(`const b${idx} = b['${field}']`)

    if (order === 'asc') {
      lines.push(`if (a${idx} === undefined && b${idx} !== undefined) return -1`)
      lines.push(`if (a${idx} !== undefined && b${idx} === undefined) return 1`)
      lines.push(`if (a${idx} === null && b${idx} !== null) return -1`)
      lines.push(`if (a${idx} !== null && b${idx} === null) return 1`)
      lines.push(`if (a${idx} < b${idx}) return -1`)
      lines.push(`if (a${idx} > b${idx}) return 1`)
    } else if (order === 'desc') {
      lines.push(`if (a${idx} === undefined && b${idx} !== undefined) return 1`)
      lines.push(`if (a${idx} !== undefined && b${idx} === undefined) return -1`)
      lines.push(`if (a${idx} === null && b${idx} !== null) return 1`)
      lines.push(`if (a${idx} !== null && b${idx} === null) return -1`)
      lines.push(`if (a${idx} < b${idx}) return 1`)
      lines.push(`if (a${idx} > b${idx}) return -1`)
    } else {
      throw new Error(`unsupported sort ordering for field ${field}: ${order}`)
    }

    idx++
  }

  lines.push('return 0')

  // eslint-disable-next-line no-new-func
  return new Function('a', 'b', lines.join('\n'))
}
